import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PassStatus } from 'src/app/enums/pass-status.enum';
import { ChangePackModal } from 'src/app/models/change-pack.model';
import { AccountService } from 'src/app/services/account.service';
import { ContentPassService } from 'src/app/services/content-pass.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ChoosePacksFlows } from 'src/app/enums/choose-packs-flows.enum';
import { Router } from '@angular/router';

@Component({
	selector: 'app-change-pack-confirmation-modal',
	templateUrl: './change-pack-confirmation-modal.component.html',
	styleUrls: ['./change-pack-confirmation-modal.component.scss']
})
export class ChangePackConfirmationModalComponent implements OnInit {

	@Input('data') data: any;
	pass: any;
	isArabic: boolean = false;
	destinationSku: any;
	constructor(private UTS: UtilitiesService,
		private modalController: ModalController,
		private CPS: ContentPassService,
		private AS: AccountService,
		private router: Router,
	) { }

	ngOnInit(): void {
		this.pass = this.data?.pass;
		this.destinationSku = this.data?.destinationSku;
		this.isArabic = this.UTS.getLocaleLanguage().toLowerCase() == 'ar';
	}
	close() {
		this.modalController.dismiss();
	}
	clickProceedNow() {
		this.AS.getAllAccount().subscribe((response: any) => {
			if (response && response.userAccounts && response.userAccounts.length > 0) {
				const account = response.userAccounts[0];
				if (account.userProfile && account.userProfile.email) {
					this.createChangePackPayloadAndActivate(account.userProfile.email);
				} else {
					this.createChangePackPayloadAndActivate(null);
				}
			}
		})
	}

	createChangePackPayloadAndActivate(email: String) {
		let accountId = localStorage.getItem('currentUserAccountId');
		let skuId = this.data?.pass?.skuId;
		const payload: ChangePackModal = {
			action: PassStatus.CHANGEPASS,
			//email: email,
			sourcePassId: skuId
		}

		this.CPS.changePassStatus(accountId, this.destinationSku.skuId, payload).subscribe((response: any) => {
			if (response) {
				this.modalController.dismiss();
				if (this.pass) {
					this.CPS.setSourceSku(this.pass)
				}
				if (this.destinationSku) {
					this.CPS.setDestinationSku(this.destinationSku)
				}
				this.router.navigateByUrl(`/subscription-successful?flow=${ChoosePacksFlows.CHANGE_PACKS}`, { replaceUrl: true });

			}
		}, (error) => {
			console.log(error);
		})
	}
	async openBottomSheet(component, data: any, classes?: any) {
		const modal = await this.modalController.create({
			component: component,
			showBackdrop: true,
			backdropDismiss: true,
			componentProps: { data: data },
			cssClass: classes || 'verification-modal modal-fullscreen',
		});
		return await modal.present();
	}

}
